module.exports = __webpack_public_path__ + "img/four2Green.2d0e4253.jpg";